<template>
  <div>
    <van-popup
      v-model="loginPopupVisible"
      :style="{
        width: '85%',
        maxWidth: '380px',
        borderRadius: '12px',
        padding: '0',
        background: '#ffffff',
      }"
      :overlay="true"
      :close-on-click-overlay="true"
      @click-overlay="close"
    >
      <div class="login-popup">
        <!-- 标题 -->
        <div class="popup-title">{{ popupTitle }}</div>

        <!-- 表单内容 -->
        <div class="form-content">
          <!-- 手机号输入框 -->
          <div class="form-item">
            <div class="form-item-label">
              <span style="color: red" class="form-item-required">*</span>
              <span>手机号</span>
            </div>
            <van-field
              v-model="formData.phoneNumber"
              placeholder="输入11位手机号（+86）"
              :border="false"
              class="custom-field"
              :maxlength="11"
              clearable
            />
          </div>

          <!-- 短信验证码输入框 -->
          <div class="form-item">
            <div class="form-item-label">
              <span style="color: red" class="form-item-required">*</span>
              <span>短信验证码</span>
            </div>
            <van-field
              v-model="formData.phoneCode"
              placeholder="输入验证码"
              :border="false"
              class="custom-field"
              clearable
            >
              <template #button>
                <van-button
                  class="btn-default"
                  :class="{ 'btn-clicked': second !== 60 }"
                  size="small"
                  type="primary"
                  @click="curAction === 'LOGIN' ? getCode() : getRegisterCode()"
                  >{{ phoneCodeBtnText }}</van-button
                >
              </template>
            </van-field>
          </div>

          <!-- 邀请码 -->
          <div class="form-item" v-if="curAction === 'REGISTER'">
            <div class="form-item-label">
              <!-- <span style="color: red" class="form-item-not-required"></span> -->
              <span>邀请码</span>
            </div>
            <van-field
              v-model="formData.code"
              placeholder="如果没有可不填"
              :border="false"
              clearable
              class="custom-field"
            />
          </div>

          <!-- 同意协议 -->
          <div class="form-item agree-action">
            <van-checkbox v-model="formData.agreeStatus" checked-color="#229652"
              >已阅读并同意<span class="highlight" @click="goToService">
                服务协议 </span
              >和<span class="highlight" @click="goToPrivacy">
                隐私政策
              </span></van-checkbox
            >
          </div>
        </div>

        <!-- 注册按钮组 -->
        <div class="button-group" v-if="curAction === 'REGISTER'">
          <van-button
            type="primary"
            round
            block
            class="submit-button"
            :loading="isRegisterSubmitting"
            loading-text="注册中"
            :disabled="!isFormValid"
            @click="handleSubmitRegister"
          >
            注册
          </van-button>
        </div>

        <!-- 登录按钮组 -->
        <div class="button-group" v-else>
          <!-- 登录按钮 -->
          <van-button
            type="primary"
            round
            block
            class="submit-button"
            :loading="isSubmitting"
            loading-text="登录中"
            :disabled="!isFormValid"
            @click="handleSubmit"
          >
            登录
          </van-button>

          <!-- 切换至注册按钮 -->
          <div class="register-button" @click="handleRegister">注册</div>
        </div>
      </div>

      <!-- 是否同意协议弹窗 -->
      <agreement-popup
        v-model="agreeVisible"
        title="服务协议和隐私政策"
        confirmButtonText="同意并注册"
        cancelButtonText="不同意"
        :content="htmlContent"
        @confirm="handleAgreeConfirm"
        @cancel="handleAgreeCancel"
        @content-click="goToProtocol"
        :contentClickable="true"
      />
    </van-popup>

    <!-- 注册提示弹窗 -->
    <status-popup
      v-model="tipsVisible"
      :type="registerSuccess ? 'success' : 'error'"
      :title="`注册${registerSuccess ? '成功' : '失败'}`"
      :description="registerFailReason"
      :show-confirm-button="false"
      :auto-close-delay="0"
    >
      <div class="tips-content">
        将在<span class="content-higlight">3秒</span>后{{registerSuccess ? '自动登录账号' : '返回注册页面'}}
      </div>
    </status-popup>

    <!-- <van-popup
      class="tips-popup"
      v-model="tipsVisible"
      :style="{
        display: 'flex',
        justifyContent: 'center',
        width: '85%',
        maxWidth: '340px',
        borderRadius: '12px',
        padding: '32px',
        background: '#ffffff',
        maxHeight: '70vh',
      }"
      :overlay="true"
      ><div>
        <div class="tips-icon"><img :src="registerSuccess ? successIcon : failIcon" /></div>
        <div class="tips-title">注册{{registerSuccess ? '成功' : '失败'}}</div>
        <div class="tips-reason" v-if="registerFailReason">{{registerFailReason}}</div>
        <div class="tips-content">
          将在<span class="content-higlight">3秒</span>后{{registerSuccess ? '自动登录账号' : '返回注册页面'}}
        </div>
      </div></van-popup
    > -->
  </div>
</template>

<script>
import { Popup, Field, Button, Checkbox, Toast, Dialog } from "vant";
import {
  loginsmscode,
  loginv2,
  usedphonenumber,
  getSmsCode,
  ckSmsCode,
  bindInviteCode,
  register,
  login,
} from "@/api/theApi";
import { mapState } from "vuex";
import * as sysTools from "../utils/sysTools";
import AgreementPopup from "./AgreementPopup.vue";
import StatusPopup from "./StatusPopup.vue";

export default {
  name: "LoginPopup",
  components: {
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    AgreementPopup,
    StatusPopup,
  },
  props: {},
  data() {
    return {
      popupTitle: "登录后可用",
      curAction: "LOGIN", // LOGIN or REGISTER
      second: 60,
      istimer: false,
      thetimer: null,
      isSubmitting: false, // 登录按钮 loading 态
      isRegisterSubmitting: false, // 注册按钮 loading 态
      agreeVisible: false, // 同意协议弹窗
      htmlContent: `已阅读并同意<span style="color: #8c5800; font-weight: 600" class="service-link" @click='goToService'> 服务协议 </span>和<span style="color: #8c5800; font-weight: 600" class="privacy-link" @click="goToPrivacy"> 隐私政策 </span>`,
      formData: {
        phoneNumber: "",
        phoneCode: "", // 验证码
        code: "", // 邀请码
        agreeStatus: false,
      },
      tipsVisible: false, // 注册成功提示弹窗
      registerSuccess: false, // 是否注册成功
      registerFailReason: "", // 注册失败原因
      // successIcon: require("@/assets/success.png"),
      // failIcon: require("@/assets/fail.png"),
    };
  },
  computed: {
    // 将 store 中的 loginPopupVisible 映射到组件的计算属性
    ...mapState(["loginPopupVisible"]),
    // 检查表单是否填写完成并有效
    isFormValid() {
      // 登录弹窗必须勾选同意协议
      if (this.curAction === "LOGIN") {
        return (
          this.formData.phoneCode.trim().length === 6 &&
          this.formData.agreeStatus &&
          this.isValidChinesePhoneNumber(this.formData.phoneNumber)
        );
      } else {
        return (
          this.formData.phoneCode.trim().length === 6 &&
          this.isValidChinesePhoneNumber(this.formData.phoneNumber)
        );
      }
    },
    phoneCodeBtnText() {
      if (this.second === 60) {
        return "获取验证码";
      } else {
        return `${this.second}后可重发`;
      }
    },
  },
  watch: {
    loginPopupVisible: {
      handler(newVal) {
        if (newVal) {
          // 弹窗打开时重置表单数据
          this.resetForm();
        }
      },
      immediate: true,
    },
    curAction: {
      handler(newVal) {
        // 登录/注册表单切换，修改弹窗标题
        if (newVal === "REGISTER") {
          this.popupTitle = "注册账号";
        } else {
          this.popupTitle = "登录后可用";
        }
        // 登录/注册表单切换，清除倒计时
        clearInterval(this.thetimer);
        this.istimer = false;
        this.second = 60;
        this.formData.phoneCode = "";
      },
      immediate: true,
    },
  },
  methods: {
    // 验证码倒计时
    timeDiDa() {
      this.istimer = true;
      this.thetimer = setInterval(() => {
        --this.second;
        if (this.second < 0) {
          clearInterval(this.thetimer);
          this.istimer = false;
          this.second = 60;
        }
      }, 1000);
    },
    /**
     * 验证是否为中国大陆有效手机号
     * @param {string|number} phone - 待验证的手机号（字符串或数字）
     * @returns {boolean} - 返回验证结果
     */
    isValidChinesePhoneNumber(phone) {
      // 转为字符串并移除所有非数字字符（允许空格/横杠等格式）
      const cleaned = String(phone).replace(/\D/g, "");
      // 基础长度验证
      if (cleaned.length !== 11) return false;
      // 最新号段正则（2025年有效）
      const pattern =
        /^1(?:3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
      return pattern.test(cleaned);
    },
    saveFilledField() {
      localStorage.setItem("loginFormData", JSON.stringify(this.formData));
    },
    getFilledFieldAfterBack() {
      const filledField = localStorage.getItem("loginFormData");
      return JSON.parse(filledField) || {};
    },
    deleteFilled() {
      localStorage.removeItem("loginFormData");
    },
    // 重置表单
    resetForm() {
      // 跳转至协议页前已填写的表单
      const filledData = this.getFilledFieldAfterBack();
      this.formData = {
        phoneNumber: filledData.phoneNumber || "",
        phoneCode: filledData.phoneCode || "",
        code: filledData.code || "",
        agreeStatus: filledData.agreeStatus || false,
      };
      this.isSubmitting = false;
      this.isRegisterSubmitting = false;
    },
    // 切换至注册
    handleRegister() {
      this.curAction = "REGISTER";
    },

    handleAgreeConfirm() {
      this.formData.agreeStatus = true;
    },
    handleAgreeCancel() {
      this.formData.agreeStatus = false;
    },

    // 关闭登录弹窗
    close() {
      this.$store.dispatch("hideLoginPopup");
    },
    goToService(event) {
      // 保存已填写的表单
      this.saveFilledField();
      this.close();
      this.$router.push({
        path: "/userservice",
      });
      event.stopPropagation();
    },
    goToPrivacy(event) {
      // 保存已填写的表单
      this.saveFilledField();
      this.close();
      this.$router.push({
        path: "/privacypollcy",
      });
      event.stopPropagation();
    },
    goToProtocol(event) {
      // 服务协议链接
      if (event.target.classList.contains("service-link")) {
        this.goToService(event);
      }
      // 隐私政策链接
      else if (event.target.classList.contains("privacy-link")) {
        this.goToPrivacy(event);
      }
    },

    // 获取登录验证码
    async getCode() {
      // 检查手机号有效性
      const isValidPhoneNumber = await this.isValidChinesePhoneNumber(
        this.formData.phoneNumber
      );
      console.log("isValidPhoneNumber", isValidPhoneNumber);
      if (!isValidPhoneNumber) {
        Toast.fail("请检查手机号是否正确");
        return;
      }
      // 检查手机号是否被注册
      const isusedres = await usedphonenumber(this.formData.phoneNumber);
      const isused = isusedres.data;
      // 手机号未注册
      if (isValidPhoneNumber && isused === "false") {
        Toast.fail("未注册,请先注册");
        this.curAction = "REGISTER";
        return;
      }
      // 手机号已注册，发送验证码
      if (isValidPhoneNumber && isused === "true") {
        this.timeDiDa();
        Toast({
          message: "验证码已发送",
          icon: "passed",
        });
        loginsmscode(this.formData.phoneNumber);
      }
    },

    // 处理登录流程
    async handleSubmit() {
      if (!this.isFormValid) {
        this.$toast("请输入正确的验证码");
        return;
      }

      this.isSubmitting = true;

      try {
        const phoneNumber = this.formData.phoneNumber;
        const phoneCode = this.formData.phoneCode;
        // const iv = this.$route.query.iv
        loginv2(phoneNumber, phoneCode)
          .then((res) => {
            if (res.login_status) {
              Toast.success("登录成功");
              this.close();
              try {
                localStorage.setItem("username", res.username);
                localStorage.setItem("login_status", res.login_status);
              } catch (error) {
                Dialog.alert(" IOS 版本不兼容，程序员小哥正在拼命修复");
              }
            } else {
              Toast.fail("登录失败");
            }
          })
          .catch(() => {
            Toast.fail("登录失败");
          });
      } catch (error) {
        console.error("提交失败:", error);
      } finally {
        this.isSubmitting = false;
        this.deleteFilled();
      }
    },

    // 获取注册验证码
    async getRegisterCode() {
      // 检查手机号有效性
      const isValidPhoneNumber = await this.isValidChinesePhoneNumber(
        this.formData.phoneNumber
      );
      console.log("isValidPhoneNumber", isValidPhoneNumber);
      if (!isValidPhoneNumber) {
        Toast.fail("请检查手机号是否正确");
        return;
      }
      if (isValidPhoneNumber) {
        // 检查手机号是否被注册
        const isusedres = await usedphonenumber(this.formData.phoneNumber);
        const isused = isusedres.data;
        // 手机号已注册，直接去登录
        if (isused === "true") {
          Toast.fail("已注册,请直接登录");
          this.curAction = "LOGIN";
          return;
        }
        // 手机号未注册，发送验证码
        const smscodeRes = await getSmsCode(this.formData.phoneNumber);
        console.log(smscodeRes);
        if (smscodeRes.code === 20000) {
          Toast({
            message: "验证码已发送，有效期10分钟",
            icon: "passed",
          });
        } else {
          Toast.fail("获取验证码失败");
        }
      }
    },

    // 处理注册流程并自动登录
    async handleSubmitRegister() {
      if (!this.formData.agreeStatus) {
        // 展示同意协议弹窗
        this.agreeVisible = true;
      }
      // 同意协议后开始注册
      if (!this.formData.agreeStatus) {
        return;
      }
      // 表单已全部填写
      if (this.isFormValid) {
        this.close();
        // 1、检查验证码是否正确，获取临时钥匙 magicKey
        let magicKey = "";
        this.isRegisterSubmitting = true;
        const ckSmsCodeRes = await ckSmsCode(
          this.formData.phoneNumber,
          this.formData.phoneCode
        );
        if (ckSmsCodeRes.code === 20000) {
          magicKey = res.data.magicKey; // 获取magickey
          if (localStorage.getItem(INVITE_CODE_KEY)) {
            // 2、绑定邀请码？
            bindInviteCode({
              username: this.formData.phoneNumber,
              code: this.formData.code,
              inviteCode: localStorage.getItem(INVITE_CODE_KEY),
            });
          }
          // 3、根据临时钥匙 magicKey 注册账号，获取 password
          const registerObj = {
            nativeCode: "imAinvestcnabc",
            phonenumber: this.formData.phoneNumber,
            username: this.formData.phoneNumber,
            mk: sysTools.b64encode(magicKey),
          };
          const registerRes = await register(registerObj);
          if (registerRes.code === 20000) {
            // 解码返回的 password
            const thepwd = sysTools.b64decode(registerRes.data.pw);
            // Toast.success("注册成功，将在3秒后自动登录账号");
            this.tipsVisible = true;
            // todo:  是否需要检测登录状态？
            // 4、登录
            const loginAfterRegisterRes = await login(
              this.formData.phoneNumber,
              thepwd
            );
            if (loginAfterRegisterRes.status_code === "20000") {
              this.isRegisterSubmitting = false;
              Toast.success("登录成功");
              this.tipsVisible = false;
            } else {
              Toast.fail("登录失败");
              this.tipsVisible = false;
            }
          } else {
            // Toast.fail("注册失败" + registerRes.msg);
            this.registerFailReason = registerRes.msg;
            this.tipsVisible = true;
            setTimeout(() => {
              this.tipsVisible = false;
            }, 3000);
          }
        } else {
          Toast.fail(ckSmsCodeRes.msg);
        }
      }
      this.deleteFilled();
    },
  },
};
</script>

<style lang="less" scoped>
.login-popup {
  padding: 32px 24px 24px;
}

.popup-title {
  text-align: center;
  font-size: 17px;
  color: #323233;
  margin-bottom: 32px;
  line-height: 1.4;
}

.form-content {
  margin-bottom: 16px;
}

.form-item {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }

  .form-item-label {
    font-size: 15px;
    color: #4e5969;
    margin-bottom: 8px;
    .form-item-required {
      padding-right: 8px;
    }
    .form-item-not-required {
      padding-right: 15px;
    }
  }
  .btn-default {
    color: #000;
    padding: 0;
    font-weight: 600;
    font-size: 14px;
    transform: translateX(4px);
    border: none;
    background: none;
  }
  .btn-clicked {
    color: #00000066;
  }
}
.form-item.agree-action {
  font-weight: 400;
  font-size: 12px;
  color: #1d2129;
  margin-top: 32px;
  .highlight {
    font-weight: 600;
    color: #8c5800;
  }
  .van-radio__icon--checked .van-icon {
    // color: #229652;
  }
}

.custom-field {
  background-color: #f7f8fa;
  border-radius: 2px;
  padding: 6px 16px;

  :deep(.van-field__control) {
    font-size: 16px;
    color: #323233;
    background-color: transparent;

    &::placeholder {
      color: #c8c9cc;
      font-size: 16px;
    }
  }

  :deep(.van-field__body) {
    background-color: transparent;
  }
}

.button-group {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.submit-button {
  width: 100%;
  height: 36px;
  background-color: #000;
  border-color: #000;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
  border-radius: 24px;

  &:active {
    background-color: #000;
    border-color: #000;
  }

  &.van-button--disabled {
    background-color: #999;
    border-color: #999;
    color: #ffffff;
  }

  :deep(.van-loading__spinner) {
    color: #ffffff;
  }
}

.register-button {
  font-size: 16px;
  color: #86909c;
  cursor: pointer;
  padding: 8px 16px;
  font-weight: 400;
  &:active {
    color: #646566;
  }
}

.tips-content {
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  color: #00000080;
  .content-higlight {
    font-weight: 600;
    font-size: 14px;
    text-align: center;
  }
}

// .tips-popup {
//   .tips-icon {
//     width: 100%;
//     padding-bottom: 20px;
//     display: flex;
//     justify-content: center;
//     & > img {
//       width: 64px;
//     }
//   }
//   .tips-title {
//     padding-bottom: 16px;
//     font-weight: 400;
//     font-size: 20px;
//     text-align: center;
//     color: #000;
//   }
//   .tips-reason {
//     font-weight: 400;
//     font-size: 14px;
//     text-align: center;
//     color: #00000080;
//     margin-bottom: 6px;
//   }
//   .tips-content {
//     font-weight: 400;
//     font-size: 14px;
//     text-align: center;
//     color: #00000080;
//     .content-higlight {
//       font-weight: 600;
//       font-size: 14px;
//       text-align: center;
//     }
//   }
// }
</style>
